export const FETCH_ALL_APPS = 'FETCH_ALL_APPS';
export const GET_APP_INFO = 'GET_APP_INFO';
